// Datasheet state model + shared field definitions.
// Field defs and asset helpers are sourced from badges.js (ported from v7) so
// the editor, preview and code generator all share one source of truth.
import {
  PRODUCT_DETAIL_FIELDS,
  VARIANT_FIELDS,
  COMMON_SPEC_FIELDS,
  DEFAULT_DISCLAIMER,
  ACCESSORY_BADGES,
  badgeExists,
} from './badges';

export { PRODUCT_DETAIL_FIELDS, VARIANT_FIELDS, COMMON_SPEC_FIELDS, DEFAULT_DISCLAIMER };

// Product Details entries (preset + custom) in the user-chosen display order.
export function detailEntries(sheet) {
  const s = sheet || {};
  const entries = PRODUCT_DETAIL_FIELDS.map(f => ({ key: f.id, type: 'preset', field: f }));
  (s.productDetailsCustom || []).forEach((c, i) => entries.push({ key: 'custom:' + i, type: 'custom', index: i, row: c || {} }));
  const order = Array.isArray(s.detailOrder) ? s.detailOrder : [];
  if (!order.length) return entries;
  const pos = {};
  order.forEach((k, i) => { pos[k] = i; });
  return entries.map((e, i) => ({ ...e, _n: i })).sort((a, b) => {
    const ai = pos[a.key] !== undefined ? pos[a.key] : 1000 + a._n;
    const bi = pos[b.key] !== undefined ? pos[b.key] : 1000 + b._n;
    return ai - bi;
  });
}

// True when the datasheet renders a second page (bezel / accessories / photometrics).
export function sheetHasPage2(s) {
  if (!s) return false;
  const bezel = (s.bezelOptions || []).some(b => b && (b.image || (b.name || '').trim()));
  const acc = (s.accessories || []).some(a => a && (a.image || (a.name || '').trim() || (a.code || '').trim()));
  const photos = (s.photometrics || []).some(p => p && (p.image || (p.label || '').trim()));
  const accBadges = ACCESSORY_BADGES.some(k => (s.badges || {})[k] && badgeExists(k));
  return bezel || acc || photos || accBadges;
}

export function defaultSheet() {
  return {
    name: '', variant: '', code: '', corner: '', family: '',
    productImage: '', dimensionsImage: '', extraImage: '',
    productDetails: {}, productDetailsCustom: [], detailOrder: [],
    badges: {}, beamCols: [], lumensContext: '',
    variants: [], variantColumns: [], commonSpecs: {}, commonSpecsCustom: [],
    bezelOptions: [], accessories: [],
    photoSubtitle: 'standard beam angles, alternative available on request',
    photometrics: [],
    salesDescription: '', purchaseDescription: '',
    internalNote: '',
    disclaimer: DEFAULT_DISCLAIMER,
  };
}

export const SCOPE_LABEL = { core: 'Core Range', customer: 'Customer Specific', personal: 'Personal / Project' };
export const SCOPE_SHORT = { core: 'Core', customer: 'Customer', personal: 'Personal' };
export const ROLES = {
  master_admin: 'Master',
  management: 'Management',
  technical_management: 'Technical Management',
  sales_rep: 'Sales Rep',
  project_coordinator: 'Project Coordinator',
  sales_support: 'Sales Support',
  accounting: 'Accounting',
  executive: 'Executive',
  us_datasheet_creator: 'US Datasheet Creator',
};
